import { createActions } from '../../shared/actions';
import { alertCreator } from '../../shared/utils';
import {
  namespace,
  typeExportTemplate,
  typeUploadFile
} from './constants';

const exportTemplate = createActions(typeExportTemplate, namespace, {
  failed: { metaCreator: alertCreator },
  original: {
    payloadCreator() {
      return {
        ajaxOptions: {
          endpoint: '/inventory',
          method: 'GET',
          responseType: 'blob'
        },
        filename: 'plantilla_carga.xlsx'
      };
    }
  },
  succeeded: { metaCreator: alertCreator }
});

const uploadFile = createActions(typeUploadFile, namespace, {
  failed: { metaCreator: alertCreator },
  original: {
    payloadCreator(payload) {
      const { data, ...morePayload } = payload;
      return {
        ajaxOptions: {
          body: data,
          endpoint: '/inventory',
          method: 'POST',
          timeout: 0
        },
        ...morePayload
      };
    }
  },
  succeeded: { metaCreator: alertCreator }
});

export default {
  ...exportTemplate,
  ...uploadFile
};



// WEBPACK FOOTER //
// ./src/containers/DashboardMassUpload/actions.js